import React, { useEffect } from "react";
import { GridStack } from "gridstack";
import GridItem from "../../../Components/UiComponents/GridItem/GridItem";
import DMSHeader from "../DMSHeader/DMSHeader";
import { useTranslation } from "react-i18next";
import DetailsAuditHistory from "./DetailsAuditHistory";
import { useNavigate } from "react-router-dom";

const DetailsAuditHistoryMain = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  useEffect(() => {
    GridStack.init();
  }, []);
  const handleBackClick = () => {
    navigate("/grievance/audit-history"); // Navigate to audit history page
  };
  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 1,
      component: (
        <DMSHeader
          title={t("details-audit-history")}
          showmenu={true}
          showdownload={false}
          showIconsForback={true}
          showImportDropDownLabel={false}
          onBackClick={handleBackClick}
        />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 11,
      id: 2,
      component: <DetailsAuditHistory />,
    },
  ];

  return (
    <div className="grid-stack grid-stack-instance-1 smartpole__header--transition">
      <GridItem layoutData={layoutData} />
    </div>
  );
};

export default DetailsAuditHistoryMain;
